import AuthHelper from 'features/Auth/authHelper';
import AccountHelper from 'features/Account/accountHelper';
import AppRoute from 'general/constants/AppRoute';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import RoleUtils from 'general/utils/RoleUtils';
import { useRoutePermission } from 'hooks/useRoutePermission';
import { Navigate } from 'react-router-dom';
import KTPageError01 from '../OtherKeenComponents/KTPageError01';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import _ from 'lodash';

// Route yeu cau phai dang nhap
// Neu chua dang nhap nhay ve man hinh dang nhap '/sign-in'
function PrivateRoute(props) {
  // MARK: --- Params ---
  const isAuth = AuthHelper.checkAccessTokenValid() ?? false;
  const { user, agencyRoleList, permissionList } = useSelector((state) => state.auth);
  const savedActiveRole = localStorage.getItem(PreferenceKeys.savedActiveRole);
  const savedUiMode = localStorage.getItem(PreferenceKeys.savedUiMode);
  const [profileLoadFailed, setProfileLoadFailed] = useState(false);

  const { hasPermission, isPermissionReady } = useRoutePermission(user, agencyRoleList, permissionList);

  useEffect(() => {
    let isMounted = true;
    if (isAuth && _.isEmpty(user)) {
      AccountHelper.callApiGetProfile().then((profile) => {
        if (isMounted && !profile) setProfileLoadFailed(true);
      });
    }
    return () => {
      isMounted = false;
    };
  }, [isAuth, user]);

  if (!isAuth) return <Navigate to={`${AppRoute.auth}/sign-in`} replace />;

  if (profileLoadFailed) {
    AuthHelper.signOut();
    return <Navigate to={`${AppRoute.auth}/sign-in`} replace />;
  }

  if (_.isEmpty(user)) {
    return RoleUtils.isCustomerUiRole(savedActiveRole, savedUiMode) ? (
      <Navigate to={AppRoute.customerHome} replace />
    ) : (
      <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light font-weight-bolder">
        Đang tải...
      </div>
    );
  }

  if (RoleUtils.isCustomerUiRole(user?.role, savedUiMode)) {
    return <Navigate to={AppRoute.customerHome} replace />;
  }

  if (!isPermissionReady) {
    return (
      <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light font-weight-bolder">
        Đang tải...
      </div>
    );
  }

  return hasPermission ? props.children : <KTPageError01 />;
}

export default PrivateRoute;
